module.exports = __webpack_public_path__ + "static/media/Sec-1_1banner.7473aa05.jpg";